var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// src/core/components/shop/Cart/CheckoutFlow.tsx
import { useState } from "react";
import DonationForm from "./DonationForm";
import UserInformationForm from "./UserInformationForm";
import { useCart } from "@/core/context/CartContext";
const CheckoutFlow = ({ onClose }) => {
    const [step, setStep] = useState("donation");
    const [donationInfo, setDonationInfo] = useState({
        type: "",
        amount: "",
    });
    const { state } = useCart();
    const handleDonationNext = () => {
        setStep("userInfo");
    };
    const handleUserInfoSubmit = (userInfo) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // Include both cart items and donation in the request
            const requestBody = {
                cartItems: [...state.items],
                customerEmail: userInfo.email,
                customerPhone: userInfo.phone,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
            };
            const response = yield fetch("https://623rv9idyg.execute-api.us-east-1.amazonaws.com/PROD/payment", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = yield response.json();
            const parsedBody = JSON.parse(data.body);
            if (parsedBody.session_url) {
                window.location.href = parsedBody.session_url;
            }
            else {
                console.error("No session URL in response:", data);
            }
        }
        catch (error) {
            console.error("Error creating checkout session:", error);
        }
    });
    return (_jsxs("div", { className: "w-full h-full", children: [step === "donation" && (_jsx(DonationForm, { onClose: onClose, onNext: handleDonationNext })), step === "userInfo" && (_jsx(UserInformationForm, { onBack: () => setStep("donation"), onSubmit: handleUserInfoSubmit }))] }));
};
export default CheckoutFlow;
